<template>
  <div class="mt-4">
    <h4 class="mb-1">
      <router-link
        tag="a"
        :to="'/articles/' + post.Code"
        exact
        class="article-link"
      >
        <span href="javascript:;" v-html="post.Title"></span>
      </router-link>
    </h4>
    <div class="mb-4">
      <i class="article-date">{{ new Date(Date.parse(post.Created)) | dateFormat('DD.MM.YYYY') }}</i>
    </div>
    <div v-html="post.Brief"></div>
    <div class="mt-2">
      <router-link
        tag="a"
        :to="'/articles/' + post.Code"
        exact
        class="article-link"
      >
        Читати далі &#8594;
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostListerItem',
  props: {
    post: Object
  }
}
</script>

<style lang="scss" scoped>
  .article-link {
    color: darkorange
  }
  .article-date {
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Posts/Lister/PostListerItem.vue